import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormService } from 'src/app/services/forms/form.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @ViewChildren('social') socials!: QueryList<ElementRef>;
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event): void {
    
    // this.changeIconColor()
  }

  changeIconColor(){
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    this.socials.forEach((el:any)=>
    {
      if(this.socials){
        if (scrollPosition > 150) {
          el.nativeElement.style.fill = "#8D0A1F"
  
        } else if (scrollPosition < 150 || scrollPosition === 0) {
          el.nativeElement.style.fill = '#fff';
        }else 
        el.nativeElement.style.fill = '#fff';
      };
    })

   
 }
     
     
    
  ngAfterViewInit() {
    this.changeIconColor()
    
  }

}
